// rebuild iframe placeholder to video

jQuery(document).ready(function() {
    // Load the IFrame Youtube Player API code asynchronously.
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/player_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    //list youtube element
    $('.video_youtube').each(function() {
        //alert('www')
        console.log($(this).attr('autoplay'));
        var checkAutoPlay = $(this).attr('autoplay');
        var frameYouTube = atob($(this).attr('cmdpreviewwys'));
        $(this).replaceWith(frameYouTube);
        var getYotubeIframeElem = $(this).children('.iframeYoutube');
        //ลบ style ที่ใส่ค่าไว้เพื่อไม่ให้คลิกแล้วเกิด event ต่างๆใน wys
        getYotubeIframeElem.removeAttr('style');

        //build new iframe if autoplay
        if (checkAutoPlay === 'true') {
            setTimeout(function() {
                getYotubeIframeElem.attr('src', getYotubeIframeElem.attr('src') + '&autoplay=1');
            }, 3000);
        }
    });
});
